import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./c5PDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"

import { drawSummary} from "./drawSummary";

export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);


  //console.log("Grouped Data:", grouped);
  let firstPage = true;

//drawWatermark (doc);

  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });


    
   drawSummary(doc, summary, grandTotal);

  drawFooter(doc, month, year, title);



 handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.userid ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          DirectLabour: 0,
          OnCostLabour: 0,
          DirectStore:0,
          OnCostStore: 0,
          GrandTotal:0,

          
        },
      };
    }

    groups[shop].rows.push(row);

    groups[shop].total.DirectLabour += Number(row.DirectLabour || 0);
    groups[shop].total.OnCostLabour += Number(row.OnCostLabour || 0);
    groups[shop].total.DirectStore += Number(row.DirectStore || 0);
    groups[shop].total.OnCostStore += Number(row.OnCostStore || 0);
    groups[shop].total.GrandTotal += (Number(row.GrandTotal || 0));
    

    return groups;
  }, {});
}